var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useState, useCallback, useEffect } from "react";
import { Button, Loading } from "@folio/stripes/components";
import { useIntl } from "react-intl";
import { fetchActiveImport, startImportFromNkp, } from "../../api/authorityImportService";
import { useImportProgress } from "../../hooks/useImportProgress";
import { useStableOkapiKy } from "../../hooks/useStableOkapiKy";
import { ImportProgress } from "./ImportProgress";
import { getImportTypeByKey } from "./importTypesConfig";
var IMPORT_ID_STORAGE_PREFIX = "import-id-";
export var ImportForm = function (_a) {
    var importTypeKey = _a.importTypeKey;
    var kyInstance = useStableOkapiKy();
    var formatMessage = useIntl().formatMessage;
    var _b = useState(null), importId = _b[0], setImportId = _b[1];
    var _c = useState(false), isStarting = _c[0], setIsStarting = _c[1];
    var _d = useState(null), error = _d[0], setError = _d[1];
    // Recover the import of the selected type once per type switch. A late
    // answer for a previously selected type must not overwrite the current one.
    useEffect(function () {
        setImportId(null);
        var importTypeConfig = getImportTypeByKey(importTypeKey);
        if (!importTypeConfig)
            return undefined;
        var cancelled = false;
        fetchActiveImport(kyInstance, importTypeConfig.apiValue).then(function (result) {
            if (cancelled)
                return;
            if (result === null || result === void 0 ? void 0 : result.importId) {
                setImportId(result.importId);
                sessionStorage.setItem(IMPORT_ID_STORAGE_PREFIX + importTypeKey, result.importId);
            }
            else {
                var cachedImportId = sessionStorage.getItem(IMPORT_ID_STORAGE_PREFIX + importTypeKey);
                if (cachedImportId) {
                    setImportId(cachedImportId);
                }
            }
        });
        return function () {
            cancelled = true;
        };
    }, [importTypeKey, kyInstance]);
    var progress = useImportProgress(importId);
    var isImportRunning = !!importId &&
        ((progress === null || progress === void 0 ? void 0 : progress.status) === "DOWNLOADING" || (progress === null || progress === void 0 ? void 0 : progress.status) === "RUNNING");
    var handleStartImport = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var importTypeConfig, result, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    importTypeConfig = getImportTypeByKey(importTypeKey);
                    if (!importTypeConfig) {
                        return [2 /*return*/];
                    }
                    setIsStarting(true);
                    setError(null);
                    setImportId(null);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, startImportFromNkp(kyInstance, importTypeConfig.apiValue)];
                case 2:
                    result = _a.sent();
                    setImportId(result.importId);
                    sessionStorage.setItem(IMPORT_ID_STORAGE_PREFIX + importTypeKey, result.importId);
                    return [3 /*break*/, 5];
                case 3:
                    err_1 = _a.sent();
                    console.error("Import error:", err_1);
                    setError(err_1 instanceof Error ? err_1.message : "Unknown error occurred");
                    return [3 /*break*/, 5];
                case 4:
                    setIsStarting(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); }, [importTypeKey, kyInstance]);
    return (React.createElement("div", null,
        React.createElement("div", { style: {
                marginBottom: "16px",
                display: "flex",
                gap: "8px",
                alignItems: "center",
            } },
            React.createElement(Button, { buttonStyle: "primary", onClick: handleStartImport, disabled: isStarting || isImportRunning }, formatMessage({ id: "ui-br-agency.import.button.start" })),
            isStarting && React.createElement(Loading, null)),
        error && (React.createElement("div", { style: { color: "red", marginBottom: "16px" } }, error)),
        progress && React.createElement(ImportProgress, { progress: progress })));
};
